import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'

export default ({ path }) => {
    return (
        <div className={baseStyles.root}>
            <h2>Cours de marketing en anglais (à choix)</h2>
            <PageStatus path={path} label={'J’ai rempli et validé le formulaire demandé ci-dessous.'} />
            <p>
                Certains cours de la formation sont proposés à choix en français ou en anglais. Ces opportunités permettent non seulement d’approfondir ses compétences linguistiques, mais également d’aborder une matière dans sa langue d’usage en entreprise. <strong>Les étudiant·es de 1ère année à Plein temps</strong> peuvent choisir la langue d’enseignement pour les cours de Marketing 1 et 2.
            </p>
            <p>
                Nous vous prions de nous indiquer votre choix au moyen de{' '}
                <a
                    href="https://enquete.heig-vd.ch/SurveyServer/s/HEG_Gestion_Cours/CoursachoixHEG1ere/questionnaire.htm"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CE FORMULAIRE
                </a>{' '}
                (Plein temps uniquement).
            </p>
            <p>Pour <strong>les étudiants En emploi ou à Temps partiel</strong>, les choix se feront en 2ème année.</p>
        </div>
    )
}
